import { Route, Routes } from "react-router-dom";
import UserSetting from "pages/management/setting/user/user";
import UserAddSetting from "pages/management/setting/user/user-add";
import UserModifySetting from "pages/management/setting/user/user-modify";
import RouteAccessError from "pages/RouteAccessError";
import PermissionRoute from "components/route/PermissionRoute";
import { PERMISSIONS } from "config/permissions";

export default function MonitoringSettingUserRoutes(props) {

    return (
        <Routes>
            <Route path="/">
                <Route
                    index
                    element={
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_USER_READ}
                        >
                            <UserSetting />
                        </PermissionRoute>
                    }
                />
                <Route path="modify/:id" 
                    element={ 
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_USER_READ}
                        >
                            <UserModifySetting />
                        </PermissionRoute> 
                    }
                 />
                <Route path="add" 
                    element={  
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_USER_READ}
                        >
                            <UserAddSetting />
                        </PermissionRoute> 
                    }
                />
                <Route path="*" element={ <RouteAccessError /> }/>
            </Route>
        </Routes>
    );
}